import script from "./ToolUseGuide.vue?vue&type=script&setup=true&lang=js"
export * from "./ToolUseGuide.vue?vue&type=script&setup=true&lang=js"

import "./ToolUseGuide.vue?vue&type=style&index=0&id=6f115f17&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f115f17"]])

export default __exports__